var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.41 8.12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M12 0L6.71 5.29 1.41 0 0 1.41l6.71 6.71 6.7-6.71L12 0z"
  })));
}

export default SvgChevronDown;